import { useFormContext, Controller } from "react-hook-form";
import { useRecoilValue, useSetRecoilState } from "recoil";
import TextInputHookFormDisabled from "../../../../components/TextInputHookFormDisabled";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
import { branchManagerChanged } from "../atoms/atoms";
import useGetActiveEmployees from "../../Employees/Confie/hooks/useGetActiveEmployees";
import TextInputLabelHookForm from "../../../../components/TextInputLabelHookForm";
import SelectHookFormSingle from "../../../../components/SelectHookFormSingle";
import useGetHrBusPartnerEmployees from "modules/CarrierAgreementMgmt/Employees/Confie/hooks/useGetHrBusPartnerEmployees";
import { useGetParentHierarchyById } from "modules/CarrierAgreementMgmt/Hierarchy/hooks/useGetParentHierarchyById";

const SPLCHierarchy = ({ disableFields }) => {
  const formMethods = useFormContext();
  const splcHierarchyId = formMethods.watch("splcHierarchyId");
  const { data: hierarchyData } = useGetParentHierarchyById(
    splcHierarchyId,
    false
  );
  const user = useRecoilValue(accountAtom);
  const { data: employees, isLoading: empLoading } = useGetActiveEmployees();
  const setManagerChanged = useSetRecoilState(branchManagerChanged);
  const { data: hrBusinessPartnerEmployees, isLoading: busPartnerEmpLoading } =
    useGetHrBusPartnerEmployees();

  const employeeList = employees
    ?.filter((y) => y.status !== "Terminated" && y.status !== "Inactive")
    .map((x) => {
      return {
        id: x.employeeId,
        value: x.employeeId,
        label: x.fullname + "-" + x.employeenumber,
        email: x.email,
        officeType: x.officeType,
        officeCode: x.officecode,
      };
    });

  const hrBusPartnerEmployeeList = hrBusinessPartnerEmployees?.map((x) => {
    return {
      value: x.employeeId,
      label: x.employeeNumber
        ? `${x.fullname} - ${x.employeeNumber}`
        : x.fullname,
    };
  });

  return (
    <div className="m-2 bg-white box-shadow rounded-lg h-full p-1 pb-4">
      <div className="text-quinary font-bold font-sans py-2 px-4">
        SPLC Hierarchy and Leadership
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 px-4 gap-12">
        <div className="space-y-1">
          <TextInputLabelHookForm
            name="officeHierarchyEffectiveDate"
            label="SPLC Hierarchy Effective Date"
            type="date"
            disabled={disableFields}
            required={!!splcHierarchyId}
            className={
              formMethods.formState.errors.officeHierarchyEffectiveDate &&
              "border-2 border-red-500 "
            }
            register={formMethods.register("officeHierarchyEffectiveDate", {
              required: {
                value: !!splcHierarchyId,
                message: "Required Field",
              },
            })}
          />
          <Controller
            control={formMethods.control}
            name="branchManagerId"
            render={({ field }) => (
              <SelectHookFormSingle
                field={field}
                onChange={(e) => {
                  field.onChange(e ? e.value : null);
                  formMethods.setValue("branchManagerName", e ? e.label : null);
                  setManagerChanged(true);
                }}
                value={field.value}
                options={employeeList?.filter(
                  (x) =>
                    x.officeType === formMethods.watch("officeType") &&
                    x.officeCode !== "" &&
                    x.officeCode !== null
                )}
                isLoading={empLoading}
                label="Branch Manager"
                isDisabled={
                  disableFields ||
                  (formMethods.watch("officeType") ? false : true)
                }
                placeHolder={
                  formMethods.watch("officeTypeId")
                    ? formMethods.watch("branchManagerId")
                      ? formMethods.watch("branchManagerName")
                      : undefined
                    : "Select Office Type to enable"
                }
              />
            )}
          />
        </div>
        <div className="space-y-1">
          {((!user.isFranchise && user.isNonFranchise) ||
            (formMethods.watch("officeType") &&
              formMethods.watch("officeType")?.toLowerCase() !==
                "franchise")) && (
            <>
              <Controller
                control={formMethods.control}
                name="hrBusinessPartnerId"
                render={({ field }) => (
                  <SelectHookFormSingle
                    field={field}
                    onChange={(e) => {
                      field.onChange(e ? e.value : null);
                    }}
                    value={field.value}
                    options={hrBusPartnerEmployeeList}
                    isLoading={busPartnerEmpLoading}
                    label="HR Business Partner"
                  />
                )}
              />
              <div className="py-4 space-y-4"> </div>
            </>
          )}

          {((user.isFranchise && !user.isNonFranchise) ||
            formMethods.watch("officeType")?.toLowerCase() === "franchise") && (
            <>
              <Controller
                control={formMethods.control}
                name="businessConsultantId"
                render={({ field }) => (
                  <SelectHookFormSingle
                    field={field}
                    onChange={(e) => {
                      field.onChange(e ? e.value : null);
                    }}
                    value={field.value}
                    options={employeeList}
                    isLoading={empLoading}
                    label="Business Consultant"
                    isDisabled={disableFields}
                  />
                )}
              />

              <TextInputLabelHookForm
                name="franchiseOwner"
                label="Franchise Owner"
                register={formMethods.register("franchiseOwner", {})}
                disabled={disableFields}
              />
            </>
          )}
        </div>
      </div>
      {splcHierarchyId && (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 px-4 lg:gap-12">
            <div className="space-y-2 w-full">
              <div className="h-[30px]"></div>
              <TextInputHookFormDisabled
                name="teamManagerEmployeeName"
                label="Team Manager"
                type="text"
                defaultValue={hierarchyData?.teamManagerEmployeeName}
                register={formMethods.register("teamManagerEmployeeName")}
              />
              <TextInputHookFormDisabled
                name="districtManagerEmployeeName"
                label="District Manager"
                type="text"
                defaultValue={hierarchyData?.districtManagerEmployeeName}
                register={formMethods.register("districtManagerEmployeeName")}
              />
              <TextInputHookFormDisabled
                name="directorEmployeeName"
                label="Director"
                type="text"
                defaultValue={hierarchyData?.directorEmployeeName}
                register={formMethods.register("directorEmployeeName")}
              />
              <TextInputHookFormDisabled
                name="vicePresidentEmployeeName"
                label="Vice President"
                type="text"
                defaultValue={hierarchyData?.vicePresidentEmployeeName}
                register={formMethods.register("vicePresidentEmployeeName")}
              />
              <TextInputHookFormDisabled
                name="seniorVicePresidentEmployeeName"
                label="Senior Vice President"
                type="text"
                defaultValue={hierarchyData?.seniorVicePresidentEmployeeName}
                register={formMethods.register(
                  "seniorVicePresidentEmployeeName"
                )}
              />
            </div>
            <div className="space-y-2 w-full">
              <div className="h-[30px]"></div>
              <TextInputHookFormDisabled
                name="teamHierarchyName"
                label="Team"
                type="text"
                defaultValue={hierarchyData?.teamHierarchyName}
                register={formMethods.register("teamHierarchyName")}
              />
              <TextInputHookFormDisabled
                name="districtHierarchyName"
                label="District"
                type="text"
                defaultValue={hierarchyData?.districtHierarchyName}
                register={formMethods.register("districtHierarchyName")}
              />
              <TextInputHookFormDisabled
                name="stateHierarchyName"
                label="State"
                type="text"
                defaultValue={hierarchyData?.stateHierarchyName}
                register={formMethods.register("stateHierarchyName")}
              />
              <TextInputHookFormDisabled
                name="marketHierarchyName"
                label="Market"
                type="text"
                defaultValue={hierarchyData?.marketHierarchyName}
                register={formMethods.register("marketHierarchyName")}
              />
              <TextInputHookFormDisabled
                name="businessUnitHierarchyName"
                label="Business Unit"
                type="text"
                defaultValue={hierarchyData?.businessUnitHierarchyName}
                register={formMethods.register("businessUnitHierarchyName")}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SPLCHierarchy;
